"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import DiagramCard from "@/components/diagrams/DiagramCard";
import ReverseDutchDiagram from "@/components/diagrams/ReverseDutchDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
const diagramCopy = {
  sectionTitle: {
    en: "Reverse Dutch Weave Micro-Geometry",
    zh: "反向荷兰编织微观几何构造",
    es: "Microgeometría del Tejido Reverse Dutch",
    de: "Mikrogeometrie der Panzertresse",
    fr: "Microgéométrie du Tissage Reps Inversé",
    pt: "Microgeometria da Trama Holandesa Reversa"
  },
  sectionLead: {
    en: "Visualizing the inverted wire arrangement with densely compacted fine warp wires and heavy spaced weft wires delivering extreme longitudinal tensile strength.",
    zh: "直观展示反向荷兰线径配置，高密度紧排细经丝与高强度粗纬丝搭配，提供极高的纵向抗拉破断强度。",
    es: "Visualización de la disposición invertida de alambres con urdimbre fina densa y trama gruesa espaciada.",
    de: "Darstellung der umgekehrten Drahtanordnung mit dichter Feinkette und starken Schussdrähten für extreme Zugfestigkeit.",
    fr: "Visualisation du ratio inversé à chaîne fine dense et trame robuste espacée assurant une haute résistance longitudinale.",
    pt: "Visualização da disposição invertida de fios com urdume fino denso e trama grossa espaçada para máxima resistência à tração."
  },
  cardTitle: {
    en: "Inverted Wire Ratio & Tensile Alignment",
    zh: "反向线径比与纵向受拉走向",
    es: "Relación de Alambres Invertida y Tensión Longitudinal",
    de: "Umgekehrtes Drahtverhältnis und Zugbeanspruchung",
    fr: "Ratio Inversé et Alignement Sous Traction",
    pt: "Relação Invertida de Fios e Alinhamento de Tração"
  },
  cardDesc: {
    en: "Fine warp wires absorb machine-direction pulling tension while thick transverse weft wires act as structural cross-ribs resisting necking.",
    zh: "细经丝沿走网方向承受机械牵引拉力，横向粗纬丝充当结构横向加强筋杜绝缩颈。",
    es: "Los alambres finos de urdimbre absorben la tensión de avance mientras los alambres gruesos transversales previenen el estrechamiento.",
    de: "Feine Kettdrähte nehmen die Zugkräfte auf, während dicke Schussdrähte als Querrippen ein Einschnüren des Bandes verhindern.",
    fr: "Les fils fins de chaîne absorbent la force de traction tandis que les gros fils de trame jouent le rôle de renforts transversaux.",
    pt: "Fios finos de urdume absorvem a força de tração enquanto os fios grossos transversais funcionam como nervuras estruturais."
  }
};
export default function ReverseDutchWeavePage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  const diagram = <DiagramSection id="diagram" title={pick(lang, diagramCopy.sectionTitle)} lead={pick(lang, diagramCopy.sectionLead)} tone="background">
      <div className="max-w-3xl mx-auto">
        <DiagramCard index="03" badge="ISO 9044 / ASTM E2016" title={pick(lang, diagramCopy.cardTitle)} description={pick(lang, diagramCopy.cardDesc)}>
          <ReverseDutchDiagram />
        </DiagramCard>
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagram} />;
}